import { useEffect, useState } from "react";
import axiosClient from "../api/axiosClient";
import { toast } from "react-toastify";
import "./admin.css";
import "./Dashboard.css";

const STAT_ITEMS = [
  {
    key: "totalUsers",
    icon: "👥",
    label: "Total Users",
    color: "users-card",
  },
  {
    key: "totalBikes",
    icon: "🏍️",
    label: "Total Bikes",
    color: "bikes-card",
  },
  {
    key: "totalBookings",
    icon: "📋",
    label: "Bookings",
    color: "bookings-card",
  },
  {
    key: "totalRevenue",
    icon: "💰",
    label: "Revenue",
    prefix: "₹",
    color: "revenue-card",
  },
];

function Dashboard() {
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalBikes: 0,
    totalBookings: 0,
    totalRevenue: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosClient
      .get("/admin/stats")
      .then((res) => setStats(res.data))
      .catch(() => toast.error("Unauthorized. Please login again."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="admin-page-header">
        <h1>Admin Dashboard</h1>
        <p>
          Welcome back! Monitor your rental business performance in real time.
        </p>
      </div>

      {loading ? (
        /* ── Skeleton stat cards ── */
        <div className="admin-stats-grid">
          {STAT_ITEMS.map((item) => (
            <div className="admin-skel-card" key={item.key} />
          ))}
        </div>
      ) : (
        <div className="admin-stats-grid">
          {STAT_ITEMS.map((item) => (
            <div
              className={`admin-stat-card ${item.color}`}
              key={item.key}
            >
              <div className="stat-icon">
                {item.icon}
              </div>

              <div className="stat-content">
                <div className="stat-label">
                  {item.label}
                </div>

                <div className="stat-value">
                  {item.prefix || ""}
                  {stats[item.key]}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export default Dashboard;